const COLOR = (score) => {
  if (score >= 70) return { ring: "#10B981", label: "Strong Signal" };
  if (score >= 40) return { ring: "#F59E0B", label: "Weak Signal" };
  return { ring: "#FF2A3B", label: "Critical Gap" };
};

export const ScoreGauge = ({ score = 0 }) => {
  const { ring, label } = COLOR(score);
  const circumference = 2 * Math.PI * 54;
  const offset = circumference - (score / 100) * circumference;

  return (
    <div className="flex flex-col items-center gap-3" data-testid="visibility-score-gauge">
      <div className="relative h-36 w-36">
        <svg className="h-36 w-36 -rotate-90" viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="54" fill="none" stroke="#1E293B" strokeWidth="10" />
          <circle
            cx="60"
            cy="60"
            r="54"
            fill="none"
            stroke={ring}
            strokeWidth="10"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 1.2s ease-out" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-heading text-4xl font-extrabold text-white" data-testid="visibility-score-value">{score}</span>
          <span className="text-xs text-slate-500">/ 100</span>
        </div>
      </div>
      <span className="text-sm font-semibold tracking-wide" style={{ color: ring }}>{label}</span>
      <span className="text-xs uppercase tracking-widest text-slate-500">Pulse Check&trade; Visibility Score</span>
    </div>
  );
};
